import { Component } from 'react';

export class ContactGroupContacts extends Component {
    render () 
    {
        return (
            <ul>
                {this.props.contacts.map((contact) => {
                    return <li key={contact.contactId}>
                        {contact.name}
                    </li>
                })}                   
            </ul>               
        );
    }
}